import { createTheme } from "@mui/material/styles";

// Единая типографика: Inter + системные fallback'ы с кириллицей.
// Раньше Inter стоял только на MuiTypography, из-за чего Box/div со
// строковым контентом (кириллица) проваливались в системный serif
// (Times New Roman на Windows / серифный дефолт на других ОС).
const FONT_STACK = [
  '"Inter"',
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  '"Helvetica Neue"',
  "Arial",
  '"Noto Sans"',
  "system-ui",
  "sans-serif",
].join(", ");

export const baseThemeParameters = createTheme({
  palette: {
    mode: "light",
  },
  typography: {
    fontFamily: FONT_STACK,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: FONT_STACK,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontFamily: FONT_STACK,
          fontSize: 14,
          letterSpacing: "-0,5px",
          color:
            theme.palette.mode === "dark"
              ? theme.palette.text.primary
              : theme.palette.text.primary,
        }),
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          input: {
            border: "none",
            fontSize: "14px",
          },
          "& fieldset": { border: "none" },
        },
      },
    },
    MuiIcon: {
      styleOverrides: {
        root: {
          color: "#fff !important",
        },
      },
    },
    // ---------------------------------------------------------------
    // Bottom-drawer'ы на десктопе (веб-версия): превращаем их в
    // центрированные «плавающие карточки», а не в полосу на всю ширину.
    //
    // Селектор `body.zero-desktop-shell &` работает потому, что drawer
    // рендерится в portal внутри body. Класс `zero-desktop-shell`
    // навешивает `RootLayout` при активной десктопной раскладке
    // (см. layout.tsx). В Telegram Mini App / на мобиле — класса нет,
    // всё выглядит по-старому.
    //
    // Обошли modification transform (его переопределяет Slide-transition
    // из самого MUI), используя left+margin-left трюк.
    // ---------------------------------------------------------------
    MuiDrawer: {
      styleOverrides: {
        paperAnchorBottom: ({ theme }) => ({
          "body.zero-desktop-shell &": {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            // `!important` нужен, чтобы перекрыть inline-transform от
            // MUI Slide-transition (иначе paper улетает вниз при закрытии
            // и не центрируется).
            transform: "translate(-50%, -50%) !important",
            maxWidth: 480,
            width: "min(calc(100vw - 40px), 480px)",
            maxHeight: "min(85vh, 720px)",
            borderRadius: 24,
            border: `1px solid ${
              theme.palette.mode === "dark"
                ? "rgba(255,255,255,0.06)"
                : "rgba(0,0,0,0.06)"
            }`,
            boxShadow:
              theme.palette.mode === "dark"
                ? "0 24px 80px rgba(0,0,0,0.55)"
                : "0 24px 80px rgba(15,15,18,0.12)",
          },
        }),
      },
    },
    // Backdrop под drawer'ом на десктопе — чуть темнее и с блюром,
    // чтобы контент фоново «остывал» и модалка читалась чётче.
    MuiBackdrop: {
      styleOverrides: {
        root: {
          "body.zero-desktop-shell &.MuiModal-backdrop": {
            backgroundColor: "rgba(0,0,0,0.45)",
            backdropFilter: "blur(4px)",
          },
        },
      },
    },
  },
});
